import React from "react";
import { useSuperPickemContext } from "../context/SuperPickemContext";
import SixteenTeamMobileBracket from "./SuperPickemBrackets/SixteenTeamMobileBracket";
import SixteenTeamDesktopBracket from "./SuperPickemBrackets/SixteenTeamDesktopBracket";
import { useMediaQuery } from "@mui/material";

const SuperPickemBracketPage = () => {
    const {
        picksToMake,
    } = useSuperPickemContext();

    const isMobile = useMediaQuery("(max-width: 1350px)");

    return (
        <>
            {picksToMake === 15 && (
                isMobile ? (
                    <SixteenTeamMobileBracket />
                ) : (
                    <SixteenTeamDesktopBracket />
                )
            )}
        </>
    );
};

export default SuperPickemBracketPage;